module.exports = __webpack_public_path__ + "img/btn_international_pay.02431485.png";